import {
  Stack,
  Inline,
  Heading,
  Box,
  Card,
  useThemeName,
} from 'braid-design-system';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  heading?: string;
}

// temporary for transition to new design
export const PageSection = ({ children, heading }: Props) => {
  // todo: remove after NVL
  const theme = useThemeName();
  // todo: remove after NVL
  if (theme === 'apac')
    return (
      <Card>
        <Stack space="small">
          <Inline alignY="bottom" space="xxsmall">
            {heading ? <Heading level="3">{heading}</Heading> : null}
          </Inline>
        </Stack>
        <Box marginBottom={heading ? 'large' : 'none'} />
        {children}
      </Card>
    );

  return (
    <Box>
      <Stack space="small">
        {heading ? <Heading level="4">{heading}</Heading> : null}
      </Stack>
      <Box marginBottom={heading ? 'medium' : 'none'} />
      {children}
    </Box>
  );
};
